import React from 'react';

import { CellRendererProps } from '../../DataTable.types';

import CommentsBox from '../../../../CommentsBox/CommentsBox';
import { DealStatus } from '../../../../../store/investor/reducer';

export const CommentCellRenderer: React.FC<CellRendererProps> = ({ row, value, dynamicProps }) => {
    const { source, getOrgId, isDealView } = dynamicProps ?? {};

    // if (row?.dealStatus === DealStatus.DRAFT) return null;
    const borrowerName = dynamicProps?.borrowerName ? dynamicProps?.borrowerName(row) : row?.borrowerName ?? '';

    return (
        <CommentsBox
            source={source}
            comments={value}
            assesseeOrgId={getOrgId(row)}
            dealIdForInvestorDeal={isDealView ? row?.id : row?.parentDealId ?? ''}
            dealId={row.dealId ?? ''}
            borrowerName={borrowerName}
            lenderName={row?.lenderName ?? ''}
        />
    );
};
